<div class="container" style="display: flex; flex-direction:column; justify-content: space-between; height:100%">

  <h3 i18n class="display-6"
    align="center"
    style="padding-top: 10px; color: #005d87; font-weight: bold;">
    {dialogMode, select, edit {Edit Vessel} other {Add Vessel}}
  </h3>

  <form [formGroup]="vesselForm">


    <!-- Vessel Questions -->

    <div class="row">

      <h6 i18n class="small-header">
        Vessel Name
      </h6>
      <mat-form-field>
        <mat-label i18n>
          Vessel Name
        </mat-label>
        <input matInput
          required
          maxlength="50"
          formControlName="vesselName"
          (input)="sharedMethodsService.forbidWhitespaceOnly('vesselName', vesselForm)">
          @if (vesselForm.get('vesselName')?.errors?.required) {
            <mat-error i18n>
          Required
        </mat-error>
          }
        </mat-form-field>

        <h6 i18n class="small-header">
        Vessel Registration Number
      </h6>
        <mat-form-field>
          <mat-label i18n>
          VRN
        </mat-label>
          <input matInput
            required
            maxlength="16"
            formControlName="vesselNumber"
            (input)="sharedMethodsService.forbidWhitespaceOnly('vesselNumber', vesselForm)">
            @if (vesselForm.get('vesselNumber')?.errors?.required) {
              <mat-error i18n>
          Required
        </mat-error>
            }
          </mat-form-field>

          @if (vrnLocked) {
            <h6 i18n class="small-header" style="font-weight: normal;">
              The VRN cannot be changed while this vessel is registered to a logbook.
            </h6>
          }

        </div>

        @if (duplicateVesselFlag) {
          <h6 i18n class="red-header"
            >
      Please enter a different VRN.
    </h6>
        }

      </form>

      <!-- Back and Add buttons -->
      <div class="row bottom-buttons">

        <div class="outer">

          <div class="inner" style="margin-right: 50%">
            <button i18n mat-stroked-button
              type="button"
              style="background-color: #005d87; color: white; font-weight: bold;"
              (click)="exitDialog()">
          Back
        </button>
          </div>

          <div class="inner">
            <button i18n mat-stroked-button
              align="end"
              type="submit"
              style="background-color: #ff6f61; color: white; font-weight: bold;"
              (click)="addVessel()">
          {dialogMode, select, edit {Save} other {Add}}
        </button>
          </div>

        </div>

      </div>

    </div>
